import axiosInstance from './axiosConfig';

/**
 * Client for the ATOZAS Workspace Launcher backend.
 * Thin wrappers around /api/workspace/* returning the unwrapped payload.
 */
export const workspaceApi = {
  getApps: () => axiosInstance.get('/api/workspace/apps').then((r) => r.data),
  getRecent: () => axiosInstance.get('/api/workspace/recent').then((r) => r.data),
  getFavorites: () => axiosInstance.get('/api/workspace/favorites').then((r) => r.data),
  getSummary: () => axiosInstance.get('/api/workspace/summary').then((r) => r.data),
  getSuggestions: () => axiosInstance.get('/api/workspace/suggestions').then((r) => r.data),
  /** Everything the Workspace dashboard renders, in one round trip. */
  getDashboard: () => axiosInstance.get('/api/workspace/dashboard').then((r) => r.data),
  getSettings: () => axiosInstance.get('/api/workspace/settings').then((r) => r.data),
  updateSettings: (payload) =>
    axiosInstance.put('/api/workspace/settings', payload).then((r) => r.data),
  resetSettings: () => axiosInstance.post('/api/workspace/settings/reset').then((r) => r.data),
  open: (appId) => axiosInstance.post('/api/workspace/open', { appId }).then((r) => r.data),
  favorite: (appId, favorite) =>
    axiosInstance.post('/api/workspace/favorite', { appId, favorite }).then((r) => r.data),
  hide: (appId, hidden) =>
    axiosInstance.post('/api/workspace/hide', { appId, hidden }).then((r) => r.data),
  reorder: (appOrder) =>
    axiosInstance.post('/api/workspace/reorder', { appOrder }).then((r) => r.data),
  updatePreferences: (payload) =>
    axiosInstance.post('/api/workspace/preferences', payload).then((r) => r.data),
};

export default workspaceApi;
